import React from "react";
import { Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import { DefaultTextInput, DropdownInput } from "@/components/Inputs";
import { AccountDetailsSectionProps } from "./AccountDetailsSection.types";

const account_fields = [
    {
        name: "display_name",
        label: "Name",
        default_disabled: false,
        type: "text",
    },
    {
        name: "account_id",
        label: "Account ID",
        default_disabled: true,
        type: "text",
    },
    {
        name: "created",
        label: `Created`,
        default_disabled: true,
        type: "text",
    },
    {
        name: "last_modified",
        label: `Last Modified`,
        default_disabled: true,
        type: "text",
    },
    {
        name: "strategy",
        label: `Strategy (Legacy)`,
        default_disabled: false,
        type: "text",
    },
    {
        name: "strategy_id",
        label: `Linked Strategy`,
        default_disabled: false,
        type: "dropdown",
    },
];

export const AccountDetailsSection: React.FC<AccountDetailsSectionProps> = ({
    accountForm,
    strategies,
    isEditMode,
    onToggleEditMode,
    onSave,
    onChange,
    onStrategyChange,
}) => {
    return (
        <>
            <div
                className="pulse-row"
                style={{ justifyContent: "space-between" }}
            >
                <p className="pulse-typography-headline-6 pulse-color--background-100">
                    Account Details
                </p>

                <IconButton
                    onClick={onToggleEditMode}
                    className="account-modal-dialog-content-button"
                >
                    {isEditMode ? <EditOffIcon /> : <EditIcon />}
                </IconButton>
            </div>
            <div className="pulse-row pulse-gap-1 pulse-p-1 api-keys-form-container">
                {account_fields.map((field: any) => {
                    if (field.type === "dropdown" && field.name === "strategy_id") {
                        const dropdownOptions = [
                            { label: "None", value: "" },
                            ...strategies.map((strategy) => ({
                                label: strategy.display_name,
                                value: strategy.strategy_id,
                            })),
                        ];

                        return (
                            <div
                                key={field.name}
                                className="pulse-default-text-input pulse-br-sm pulse-mb-2 pulse-col-xs-6 pulse-col-sm-6 pulse-col-md-6 pulse-col-lg-6 pulse-col-xl-6"
                            >
                                <label className="pulse-color--background-50 pulse-typography-body-2 pulse-mb-1">
                                    {field.label}
                                </label>
                                <DropdownInput
                                    value={accountForm.strategy_id || ""}
                                    label=""
                                    onChange={(e: any) => {
                                        const value = e.target.value === "" ? null : e.target.value;
                                        onStrategyChange(value);
                                    }}
                                    name={field.name}
                                    options={dropdownOptions}
                                    formInput={false}
                                    containerClassNames=""
                                    disabled={!isEditMode || field.default_disabled}
                                    omitEmptyOption={true}
                                    selectSx={{
                                        color: "#e8eaef",
                                        "& .MuiSelect-select.Mui-disabled": {
                                            WebkitTextFillColor: "#627195",
                                        },
                                    }}
                                />
                            </div>
                        );
                    }
                    return (
                        <DefaultTextInput
                            key={field.name}
                            name={field.name}
                            label={field.label}
                            value={accountForm && (accountForm as any)?.[field.name]}
                            onChange={onChange}
                            containerClassNames="pulse-default-text-input pulse-br-sm pulse-mb-2 pulse-col-xs-6 pulse-col-sm-6 pulse-col-md-6 pulse-col-lg-6 pulse-col-xl-6"
                            labelClassNames={`pulse-color--background-50 pulse-typography-body-2 pulse-mb-1`}
                            inputClassNames="pulse-bg-color--background-800 pulse-typography-body-2"
                            type={field.type}
                            disabled={!isEditMode || field.default_disabled}
                        />
                    );
                })}
            </div>

            {isEditMode && (
                <Button
                    onClick={() => onSave(accountForm)}
                    variant="contained"
                    className="account-modal-dialog-content-save-account-button"
                >
                    Save Account Details
                </Button>
            )}
        </>
    );
};
